import React from "react";
import Select from "react-select";

class SelectBox extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      customstyle: {
        groupHeading: (provided) => ({
          ...provided,
          fontSize: 16,
          fontWeight: 900,
          borderBottom: "1px solid #f2f2f2"
        }),
        option: (provided) => ({
          ...provided,
          fontSize: 12,
        })
      }
    }
  }

  
  render() {
    return (
      <Select {...this.props} ref={this.props.inputRef} styles={this.state.customstyle} classNamePrefix="gst" />

    )
  }
}

export default React.forwardRef((props, ref) => {
  return (<SelectBox inputRef={ref} {...props} />)
});
